<template>
  <DefaultLayout>
    <div class="grid sm:grid-cols-2 grid-cols-1 gap-4 mt-10">
      <div class="bg-white dark:bg-gray-800 rounded-lg p-5 flex w-full justify-between items-center">
        <div class="space-y-1">
          <div class="dark:text-gray-200">الطلاب</div>
          <div class="text-2xl font-meduim dark:text-gray-100">
            {{ students?.length ?? 0 }}
          </div>
        </div>

        <div class="text-2xl font-meduim text-green-500">
          <span class="icon-[ph--users-three] size-10"></span>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg p-5 flex w-full justify-between items-center">
        <div class="space-y-1">
          <div class="dark:text-gray-200">الحلقات</div>
          <div class="text-2xl font-meduim dark:text-gray-100">
            {{ sessions?.length ?? 0 }}
          </div>
        </div>

        <div class="text-2xl font-meduim text-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-10"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <PresenceChart />

      <!-- <div v-if="students">
        <StudentsAgeDistribution :students="students" />
      </div>

      <div v-if="students">
        <StudentsNationalityDistribution :students="students" />
      </div>
      <div v-if="students">
        <StudentsEducationalStageDistribution :students="students" />
      </div>

      <div v-if="students">
        <StudentsEducationTypeDistribution :students="students" />
      </div> -->
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-lg p-5 flex flex-col w-full mt-4 gap-4">
      <div class="dark:text-gray-200">إجمالي عدد الطلاب لكل جزء:</div>

      <div
        class="flex items-center gap-2 overflow-x-auto py-3 shadow cursor-pointer"
        ref="tabWrapper"
      >
        <div
          v-for="juz in filteredJuzs"
          :key="juz.index"
          ref="tablist"
          @click="selectJuz(juz)"
          class="p-2 px-4 min-w-fit border-primary dark:border-gray-600 border rounded-lg dark:text-gray-200"
          :class="{ 'bg-gray-100 dark:bg-gray-700': selectedJuz?.index === juz.index }"
          v-track="TrackingEvents.VIEW_JUZ_STUDENTS"
        >
          <!-- {{ juz }} -->
          <div>الجزء {{ juz.index }}</div>
          <div class="text-primary dark:text-blue-400">
            {{ juz.students.length }}
          </div>
        </div>
      </div>
    </div>

    <TransitionRoot appear :show="showJuzModal" as="template">
      <Dialog as="div" @close="closeModal" class="relative z-10">
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-black/25" />
        </TransitionChild>
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-4 text-center">
              <DialogPanel
                dir="rtl"
                v-if="selectedJuz"
                class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all"
              >
                <DialogTitle
                  as="h3"
                  class="leading-6 text-gray-900 dark:text-gray-100 text-right flex justify-between items-center"
                >
                  <div class="text-2xl">الطلاب في الجزء {{ selectedJuz.index }}</div>
                </DialogTitle>
                <div class="mt-5 flex flex-col gap-3">
                  <div
                    class="flex flex-col gap-3 p-3 bg-gray-50 dark:bg-gray-700 dark:text-gray-200 items-center rounded"
                    v-for="student in selectedJuz.students"
                  >
                    <div class="min-w-9 text-center">
                      {{ student.name }}
                    </div>

                    <div>
                      {{ quran.find((s) => s.id == student.last_memorization_surah_number)?.name }}
                      ({{ student.last_memorization_verses }})
                    </div>
                  </div>
                </div>

                <div class="mt-4 flex justify-start gap-2">
                  <button
                    type="button"
                    class="bg-primary dark:bg-blue-600 text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-primary/90 dark:hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75"
                    @click="closeModal"
                  >
                    اغلاق
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </TransitionChild>
      </Dialog>
    </TransitionRoot>
  </DefaultLayout>
</template>

<script setup lang="ts">
import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/vue'
import DefaultLayout from '@/layouts/Default.vue'
import { allSessions } from '@/queries/sessions'
import { allStudents, useStudents } from '@/queries/students'

import juzs from '@/quran/juz.json'
import quran from '@/quran/index.json'
import { computed, nextTick, ref } from 'vue'
import type { Student } from '@/types/global'
import { TrackingEvents } from '@/enums/trackingEvents'
import PresenceChart from '@/components/charts/PresenceChart.vue'
import StudentsAgeDistribution from '@/components/charts/StudentsAgeDistribution.vue'
import StudentsNationalityDistribution from '@/components/charts/StudentsNationalityDistribution.vue'
import StudentsEducationalStageDistribution from '@/components/charts/StudentsEducationalStageDistribution.vue'
import StudentsEducationTypeDistribution from '@/components/charts/StudentsEducationTypeDistribution.vue'

type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never

type Juz = ArrayElement<typeof juzs> & { students: Student[] }

const { data: sessions } = allSessions((data) => data, ['name'])
const { data: students } = allStudents([
  'name',
  'last_memorization_surah_number',
  'last_memorization_verses',
  'date_of_birth',
  'nationality_id',
  'educational_stage',
  'education_type'
])

const showStudentsInfo = ref(false)

const tablist = ref<HTMLDivElement[]>([])
const tabWrapper = ref<HTMLDivElement | null>(null)

async function closeModal() {
  showJuzModal.value = false

  await nextTick()
  selectedJuz.value = null
}

async function selectJuz(j: Juz) {
  selectedJuz.value = j

  showJuzModal.value = true
}

const selectedJuz = ref<Juz | null>(null)

const showJuzModal = ref(false)

const filteredJuzs = computed(() => {
  const cStudents = [...(students.value ?? [])]

  function between(number: number, lower: number, upper: number) {
    return (number >= lower && number <= upper) || number == lower || number == upper
  }

  function doesStudentBelongToJuz(s: Student, j: (typeof juzs)[number]) {
    if (j.start.index == j.end.index) {
      return (
        s.last_memorization_surah_number == j.start.index &&
        between(s.last_memorization_verses, j.start.verse, j.end.verse)
      )
    } else {
      return between(s.last_memorization_surah_number, j.start.index, j.end.index)
    }
  }

  return juzs.map((j) => {
    const juzStudents = []

    for (const index in cStudents) {
      if (doesStudentBelongToJuz(cStudents[index], j)) {
        juzStudents.push(...cStudents.splice(parseInt(index), 1))
      }
    }

    return {
      ...j,
      students: juzStudents.sort(
        (a, b) => a.last_memorization_surah_number - b.last_memorization_surah_number
      )
    }
  })
})
</script>

<style scoped></style>
